import dialogs from '../core/dialog';
import authorization from '../api/authorization';
import { Distances } from '../api/endpoints/distance/distances';
import { notify, NOTIFY_TYPE, notifySuccess } from '../shared';
import { FeaturePermission } from '../../constants/feature.permission.helper';

export interface routingOption {
    text: string;
    handler: () => void | Promise;
    hidden: boolean;
    useQuota: boolean;
}

type fromRoutingOptionEnum = 'fromStore' | 'fromCity';

export interface originDistanceInfo {
    type: fromRoutingOptionEnum;
    name: string;
    id: number;
}

type handlerChosenOption = (id: number, name: string) => void;

type dicHandler = {
    type: fromRoutingOptionEnum;
    handler: handlerChosenOption;
}

export default class DistanceReportInfo {
    originData: originDistanceInfo;
    quotas: number = 0;

    constructor(originData: originDistanceInfo, otherOptions: routingOption[] = []) {
        this.originData = originData;
        this.openDialog(otherOptions);
    }

    openDialog = (plusOptions: routingOption[]): void => {
        const { isAuthorized } = authorization;

        const fixedOptions: routingOption[] = [
            {
                text: '25 Lojas mais próximas',
                handler: this.generateToNearestStores,
                hidden: !isAuthorized(FeaturePermission.MAP_ROUTES.NearestStores),
                useQuota: true
            },
            {
                text: '25 Lojas da mesma rede mais próximas',
                handler: this.generateToNearestSameBrandStores,
                hidden: this.originData.type !== 'fromStore' || !isAuthorized(FeaturePermission.MAP_ROUTES.NearestSameBrandStores),
                useQuota: true
            },
            {
                text: '25 AOPs mais próximas',
                handler: this.generateToNearestOperationalArea,
                hidden: !isAuthorized(FeaturePermission.MAP_ROUTES.NearestOperationalAreas),
                useQuota: true
            }
        ];

        const allOptions: routingOption[] = [...plusOptions, ...fixedOptions].filter(x => !x.hidden);

        if (allOptions.length === 1) {
            allOptions[0].handler();
            return;
        }

        dialogs.select(allOptions.map((x, i) => ({ value: i, text: x.text })), chosenOption => {
            const {handler, useQuota} = allOptions[chosenOption];

            if(!handler || typeof handler !== 'function')
                return;

            if (!useQuota)
                return handler();

            return this.handleQuotedChosen(handler);
        });
    };

    handleQuotedChosen = (callback: () => Promise): Promise =>
        callback()
            .then(x => this.getQuotas(() => notifySuccess({text: `Arquivo gerado com sucesso! Limite de ${this.quotas} novas rotas`})))
            .catch(err => this.getQuotas(() => {
                if(this.quotas <= 0){
                    notify(NOTIFY_TYPE.LOG, "Foi consumido o limite de rotas disponíveis");
                    return;
                }

                notify(NOTIFY_TYPE.ERROR, "Error generating report");
            }));

    generateToNearestStores = (): Promise =>
        this.executeHandlerByType([
            {type: 'fromStore', handler: Distances.getReportStoreToStores},
            {type: 'fromCity', handler: Distances.getReportCityToStores}
        ]);

    generateToNearestSameBrandStores = (): Promise =>
        this.executeHandlerByType([
            {type: 'fromStore', handler: Distances.getReportStoreToSameBrandStores}
        ]);

    generateToNearestOperationalArea = (): Promise =>
        this.executeHandlerByType([
            {type: 'fromStore', handler: Distances.getReportStoreToOperationalAreas},
            {type: 'fromCity', handler: Distances.getReportCityToOperationalAreas}
        ]);

    executeHandlerByType = (handlers: dicHandler[]): handlerChosenOption => {
        const { id, name } = this.originData;
        const handler = handlers.findOrFirst(x => x.type === this.originData.type).handler;
        return handler(id, name);
    };

    getQuotas = (callback: () => void): void => {
        Distances.getDailyQuotasLeft()
            .then(x => {
                this.quotas = x;
                callback();
            });
    };
}



// WEBPACK FOOTER //
// ./src/scripts/info/DistanceReportInfo.js